/**********************************************************
 *  Imports
 **********************************************************/

import React, { Component } from "react";
import { Switch, Route } from 'react-router-dom';

// Libraries
import ResizeAware from 'react-resize-aware';

// Views
import { Main, Login, ComingSoon, Beta, Info, OurStory } from './Views';

// Stores
import { PricingStore } from './Stores';

/**********************************************************
 * 
 *  The App class is the highest level class.  It holds the 
 *  routing references to login, main and info classes.  Also
 *  maintains the window sizing for most children
 * 
 **********************************************************/

class App extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            loggedIn : true,
            width : window.innerWidth,
            height : window.innerHeight,
            mobile : window.innerWidth < 505 ? true : false
        }

        this.updateScreenSize = this.updateScreenSize.bind(this);

    }

    componentDidMount() {

        //console.log('App.componentDidMount()');

        PricingStore.init();
    }


/**********************************************************
 *  Helper Functions
 **********************************************************/
    
    // Given a new screen size, assess if its worth changing and change it
    updateScreenSize =({width, height}) => {

        //console.log('App.updateScreenSize()');

        const mobile = width < 1024 ? true : false;

        this.setState((prevState, props) => {
            return {
                width : width,
                height : height,
                mobile : mobile
            }
        });

    }


/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('App.render()');

        return (
            <div className="App">
                <ResizeAware style={{ position: 'relative' }} onResize={this.updateScreenSize} >
                    <Switch>
                        <Route exact path={'/'} render={(props) => <Login {...props} mobile={this.state.mobile}/>} />
                        <Route path={'/markets'} render={(props) => <Main {...props} mobile={this.state.mobile} />} />
                        <Route path={'/dashboard'} render={(props) => <Main {...props} mobile={this.state.mobile}/>} />
                        <Route path={'/charts'} render={(props) => <Main {...props} mobile={this.state.mobile}/>} />
                        <Route path={'/peak'} render={(props) => <Main {...props} mobile={this.state.mobile}/>} />
                        <Route path={'/apikeys'} render={(props) => <Main {...props} mobile={this.state.mobile}/>} />
                        <Route path={`/login`} render={(props) => <Login {...props} mobile={this.state.mobile}/>} />
                        <Route path={`/activate/:username`} render={(props) => <Info view="activate" {...props} mobile={this.state.mobile}/>} />
                        <Route path={`/success/:username`} render={(props) => <Info view="success" {...props} mobile={this.state.mobile}/>} />
                        <Route path={'/comingsoon'} render={(props) => <ComingSoon />} />
                        <Route path={'/beta'} render={(props) => <Beta />} />
                        <Route path={'/our-story'} render={(props) => <OurStory />} />
                    </Switch>
                </ResizeAware>

            </div>
        );
    }
}

export default App;










// WEBPACK FOOTER //
// ./src/App.js